import { ReactNode, useEffect } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

interface ProtectedRouteProps {
  children: ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { locale } = useParams<{ locale: string }>();

  useEffect(() => {
    if (!loading && !user) {
      // Strip locale prefix from pathname to avoid duplication
      const pathnameWithoutLocale = location.pathname.replace(/^\/(?:ja|en)/, '') || '/';
      const currentPath = location.search
        ? `${pathnameWithoutLocale}${location.search}`
        : pathnameWithoutLocale;
      const nextQuery = currentPath !== '/' ? `?next=${encodeURIComponent(currentPath)}` : '';

      navigate(`/${locale}/login${nextQuery}`, { replace: true });
    }
  }, [loading, user, navigate, location.pathname, location.search, locale]);

  if (loading || !user) {
    return (
      <div className="flex h-svh flex-col items-center justify-center gap-2">
        <div className="border-muted-foreground size-6 animate-spin rounded-full border-2 border-b-transparent" />
        <p className="text-muted-foreground text-sm">Checking authentication…</p>
      </div>
    );
  }

  return <>{children}</>;
}
